export default __webpack_public_path__ + "static/media/HMDG.a048abdb.png";